
import { defineComponent, SetupContext, PropType, computed } from "vue";
import NativeClient from "@/client/native-client";
import { 
  FridgeDetailsMylistItem,
  FRIDGE_DETAILS_COOLING_MODE,
  FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING
} from "@/types/fridgeDetails";
import { secondsZeroPadding } from "@/utils/fridgeDetails-utils";
import FridgeDetailsMyAssistListItem from "./FridgeDetailsMyAssistListItem.vue";

export default defineComponent({
  name: "FridgeDetailsMyAssistList",
  components: { FridgeDetailsMyAssistListItem },
  props: {
    /** 表示する文字列 */
    myAssistList: {
      type: Array as PropType<FridgeDetailsMylistItem[]>,
      default: null
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDetailsMyAssistList setup start");

    // 定数
    const noListText = "マイリストが登録されていません。";

    const isValidList = computed(() => {
      if (props.myAssistList != null) {
        return true;
      }
      return false;
    });

    const isValidMyAssist = computed(() => {
      if (props.myAssistList != null && props.myAssistList.length > 0) {
        return true;
      }
      return false;
    });

    // リスト
    interface FridgeDetailsMyAssistDisplayItem {
      index: number;
      name: string;
      mode: string;
      timeString: string;
    }
    const list = computed(() => {
      const result: Array<FridgeDetailsMyAssistDisplayItem> = [];
      if (props.myAssistList != null) {
        for (let index = 0; index < props.myAssistList.length; index ++) {
          let mode = "";
          let timeString = "";
          switch (props.myAssistList[index].cooloven_mode) {
            case FRIDGE_DETAILS_COOLING_MODE.QUENCH:
              mode = FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING.QUENCH;
              timeString = `${props.myAssistList[index].cooloven_time}分${secondsZeroPadding(props.myAssistList[index].cooloven_second)}秒`;
              break;
            case FRIDGE_DETAILS_COOLING_MODE.COLD:
              mode = FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING.COLD;
              timeString = `${props.myAssistList[index].cooloven_time}分`;
              break;
            case FRIDGE_DETAILS_COOLING_MODE.FROZEN:
              mode = FRIDGE_DETAILS_COOLING_MODE_DISPLAY_STRING.FROZEN;
              timeString = `${props.myAssistList[index].cooloven_time}分`;
              break;
            default:
              break;
          }
          const item: FridgeDetailsMyAssistDisplayItem = { index: index, name: props.myAssistList[index].nickname, mode: mode, timeString: timeString };
          result.push(item);
        }
      }
      return result;
    });

    // タップ
    const clickItem = (index: number) => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistList clickItem(index: " + index + ")");
      if (props.myAssistList != null) {
        NativeClient.sendDebugLog("FridgeDetailsMyAssistList clickItem mylist_id = " + props.myAssistList[index].mylist_id);
        context.emit("click-item", props.myAssistList[index].mylist_id);
      }
    };
    const clickDeleteItem = (index: number, name: string) => {
      NativeClient.sendDebugLog("FridgeDetailsMyAssistList clickDeleteItem(index: " + index + ")");
      if (props.myAssistList != null) {
        NativeClient.sendDebugLog("FridgeDetailsMyAssistList clickDeleteItem mylist_id = " + props.myAssistList[index].mylist_id);
        context.emit("click-delete-item", props.myAssistList[index].mylist_id, name);
      }
    };

    return {
      isValidList,
      isValidMyAssist,
      list,
      noListText,
      clickItem,
      clickDeleteItem
    };
  }
});
